/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOffer } from '../../../selectors/selectOffer';
import { selectAgent } from '../../../selectors/selectAgent';
import { trackChartTooltipShow } from '../../../tracking';

export const useTrackTooltipShow = () => {
  const hasSent = React.useRef(false);
  const offer = useSelector(selectOffer);
  const agent = useSelector(selectAgent);

  return React.useCallback((_, elements?: any[]) => {
    if (!hasSent.current && elements && elements.length) {
      trackChartTooltipShow(offer, agent);

      hasSent.current = true;
    }
  }, []);
};
